// extracted by mini-css-extract-plugin
export default {"root":"BlockSocialMediaLink_root__Whd-G","link":"BlockSocialMediaLink_link__-0b+e","media":"BlockSocialMediaLink_media__9G3CH","text":"BlockSocialMediaLink_text__ZT7G0"};